import React, { useContext, useEffect, useState } from "react";
import ServiceWrapper from "../../../Services/ServiceWrapper";
import AuthManager from "../../../Common/AuthManager";
import AppSettings from "../../../Settings/AppSettings";
import { AppContext } from "../../../Context/AppContext";
import { useHistory } from "react-router-dom";
import GMSFillButton from "../../Common/components/GMSFillButton";
import { toast } from "react-toastify";
const CachePromotionView = () => {
  const [disableButton, setDisableButton] = useState(false);
  const [loaded, setloaded] = useState(false);
  let api_base_url = AppSettings.GMS_BACKEND_API_URL;
  const appData = useContext(AppContext);
  const history = useHistory();
  useEffect(() => {
    if (!appData.pm.checkPermission("gmscache_edit")) {
      history.push("/workspace/module/permission/denied");
    } else {
      setloaded(true);
    }
  }, []); // eslint-disable-line
  const triggerCacheRefresh = async () => {
    setDisableButton(true);
    let res = await ServiceWrapper.doGet(
      api_base_url + "masterdata/generate",
      null,
      null,
      AuthManager.getGmsToken()
    );
    if (!res.errorfound && res?.data) {
      toast.info(
        "Triggerred successfully, the button will be locked for next 7 minutes."
      );
      setTimeout(() => {
        setDisableButton(false);
      }, 420000);
    } else {
      toast.error("Error Occured");
      setDisableButton(false);
    }
  };
  return (
    <>
      {loaded && (
        <div className="border-bottom ">
          <div className="pt-2 pb-2 d-flex justify-content-between ps-4 pe-3">
            <label
              className="fs-5 fw-bolder"
              style={{
                fontFamily: "Noto Sans",
              }}
            >
              Cache Management
            </label>
            <GMSFillButton
              name="Trigger Cache"
              disabled={disableButton}
              onClick={() => {
                triggerCacheRefresh();
              }}
            />
          </div>
        </div>
      )}
    </>
  );
};
export default CachePromotionView;